export default "__VITE_ASSET__B2iuciNZ__"